/* eslint-disable no-tabs */
/* eslint-disable no-mixed-spaces-and-tabs */
/* eslint-disable */
import {
  mdiOfficeBuildingCog,
  mdiHome,
  mdiCarMultiple,
  mdiHandExtended,
  mdiClipboardCheckOutline,
  mdiAnimation,
  mdiTagText,
  mdiAccountTieHat,
  mdiRun,
  mdiAirplane,
  mdiStoreCog,
  mdiCog,
  mdiTune,
  mdiCalendarMonth,
  mdiFinance,
  mdiNotebookMultiple,
  mdiCash,
  mdiSchool,
  mdiWatermark,
  mdiCashMultiple,
  mdiFaceAgent,
  mdiAccount,
} from "@mdi/js"

export default [
  {
    label: "sidebarFin.roomBooking",
    // label: 'Room Booking',
    to: "/booking-dashboard",
    icon: mdiStoreCog,
  },
  {
    label: "sidebarFin.facilityBooking",
    // label: 'Facility Booking',
    subLabel: "Submenus Booking",
    icon: mdiStoreCog,
    menu: [
      {
        to: "/building",
        label: "sidebarFin.building",
        // label: 'Building',
        icon: mdiOfficeBuildingCog,
      },
      {
        to: "/room",
        label: "sidebarFin.room",
        // label: 'Room',
        icon: mdiHome,
        // icon: mdiAccountTie
      },
      {
        to: "/vehicle",
        label: "sidebarFin.vehicle",
        // label: 'Vehicle',
        icon: mdiCarMultiple,
        // icon: mdiAccountTie
      },
      {
        to: "/facility",
        label: "sidebarFin.facility",
        // label: 'Facility',
        icon: mdiHandExtended,
      },
      {
        to: "/facility-condition",
        label: "sidebarFin.facilityCondition",
        // label: 'Facility Condition',
        icon: mdiClipboardCheckOutline,
      },
      {
        to: "/fa-category",
        label: "sidebarFin.categoryFacility",
        // label: 'Category Facility',
        icon: mdiAnimation,
      },
      {
        to: "/pricelist",
        label: "sidebarFin.priceList",
        // label: 'Price List',
        icon: mdiTagText,
      },
      // {
      // 	to: '/owner',
      // 	label: 'Owner',
      // 	icon: mdiAccountStar
      // },
      {
        to: "/tenant",
        label: "sidebarFin.tenant",
        // label: 'Tenant',
        icon: mdiAccountTieHat,
      },
      {
        to: "/activity",
        label: "sidebarFin.activity",
        // label: 'Activity',
        icon: mdiRun,
      },
      {
        to: "/holiday",
        label: "sidebarFin.holiday",
        // label: 'Holiday',
        icon: mdiAirplane,
      },
      {
        to: "/financial-year",
        label: "finance.sidebar.master.finYear",
        icon: mdiCalendarMonth,
      },
      {
        to: "/coa",
        label: "finance.sidebar.master.coa",
        icon: mdiFinance,
        updateMark: true,
      },
      {
        to: "/typejournal",
        label: "finance.sidebar.master.journalType",
        icon: mdiNotebookMultiple,
      },
      {
        to: "/typesofincome",
        label: "finance.sidebar.incomes.incType",
        icon: mdiCash,
      },
      {
        to: "/incomegroup",
        label: "finance.sidebar.incomes.groupType",
        icon: mdiCash,
      },
    ],
  },
  {
    label: "sidebarFin.transaction",
    // label: 'Transaction',
    subLabel: "Transaction",
    icon: mdiCashMultiple,
    menu: [
      {
        to: "/transaction-type",
        label: "sidebarFin.transactionType",
        // label: 'Transaction Type',
        icon: mdiCashMultiple,
      },
      {
        to: "/transaction-group",
        label: "sidebarFin.transactionGroup",
        // label: 'Transaction Group',
        icon: mdiCashMultiple,
      },
    ],
  },
  {
    label: "sidebarFin.roles",
    // label: 'Roles',
    subLabel: "Roles",
    icon: mdiFaceAgent,
    menu: [
      {
        to: "/role",
        label: "sidebarFin.roles",
        // label: 'Role',
        icon: mdiFaceAgent,
      },
      {
        to: "/role-group",
        label: "sidebarFin.roleGroup",
        // label: 'Role Group',
        icon: mdiFaceAgent,
      },
    ],
  },
  {
    label: "sidebarFin.settings",
    // label: 'Settings',
    subLabel: "Submenus Settings Booking",
    icon: mdiCog,
    menu: [
      {
        to: "/schoolidentity",
        label: "sidebarFin.entity",
        // label: 'Entity',
        icon: mdiSchool,
      },
      {
        to: "/branch",
        label: "sidebarFin.branch",
        // label: 'Branch',
        icon: mdiWatermark,
      },
      {
        to: "/setting-rental",
        label: "sidebarFin.settingRental",
        // label: 'Setting Rental',
        icon: mdiTune,
      },
      {
        to: "/users",
        label: "sidebarFin.users",
        // label: 'Users',
        icon: mdiAccount,
      },
    ],
  },
]
